import styled from '@emotion/styled';
import { Header } from '@silvertours/front-features';

/*
 * The floating header bar has 24px inner spacing from md, as in the design.
 * Without the md rule, the sm rule (32px) would apply until lg.
 */
const StyledHeader = styled(Header)`
  background-color: ${({ theme }) => theme.colors.neutral.white100};
  padding-inline: ${({ theme }) => theme.spacing[40]};

  ${({ theme }) => theme.mq('sm')} {
    padding-inline: ${({ theme }) => theme.spacing[60]};
  }

  ${({ appearance, theme }) =>
    appearance === 'floating' &&
    `
      ${theme.mq('md')} {
        padding-inline: ${theme.spacing[50]};
      }
    `}

  ${({ theme }) => theme.mq('lg')} {
    padding-inline: ${({ theme }) => theme.spacing[50]};
  }
`;

const RegionalSettingsWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const LoginMobileMenuWrapper = styled.div`
  padding: 0 ${({ theme }) => theme.spacing[40]}
    ${({ theme }) => theme.spacing[50]};
`;

export { StyledHeader, RegionalSettingsWrapper, LoginMobileMenuWrapper };
